export const getDateSanitized = ({ date }: { date: Date }) =>
  date.setUTCHours(0, 0, 0, 0);
